
import userApi from '@/store/apis/user'
import XButton from 'vux/src/components/x-button/index.vue'

import html2canvas from 'html2canvas'
import { dataURLtoBlob } from '../../tools/url'
import { local, KEY_USER_TOKEN } from '@/tools/storage'
import thingApi from '@/store/apis/thing'
import rabbit1 from '@/assets/img/annual-report/imperial_rabbit_1.png'
import rabbit2 from '@/assets/img/annual-report/imperial_rabbit_2.png'
import ShareBar from '@/components/ShareBar'
import { ANNUAL_REPORT_YEAR } from '@/tools/constant'

const titles = {
FEMALE: [
{
value: 3000,
title: '共享皇后'
},
{
value: 1000,
title: '共享貴妃'
},
{
value: 200,
title: '共享貴人'
},
{
value: 50,
title: '共享常在'
},
{
value: 0,
title: '共享答應'
}
],
MALE: [
{
value: 3000,
title: '共享太師'
},
{
value: 1000,
title: '共享總督'
},
{
value: 200,
title: '共享巡撫'
},
{
value: 50,
title: '共享知府'
},
{
value: 0,
title: '共享知縣'
}
]
}

export default {
components: {
XButton,
ShareBar
},
data () {
return {
giveQuantity: 0,
receiveQuantity: 0,
sendFlowerCount: 0,
getFlowerCount: 0,
commonwealDonateCount: 0,
getThanksCount: 0,
momentCount: 0,
firstSender: null,
firstThank: null,
gender: 'UNKOWN',
loading: false,
step: 0,
showValue: false,
userId: '',
showAll: false,
rabbitImg: rabbit1,
timer: null,
rabbitIndex: 0,
isShowShareBar: false,
shareImage: '',
shareUrl: '',
shareLoading: false,
year: ANNUAL_REPORT_YEAR
}
},
created () {
this.getUserReport()
const { href } = window.location
if (href.indexOf('qa.give543.com') !== -1) {
this.shareUrl = 'https://m.qa.give543.com?annual_report=1'
} else if (href.indexOf('give543.com') !== -1) {
this.shareUrl = 'https://m.give543.com?annual_report=1'
} else if (href.indexOf('give-circle.com') !== -1) {
this.shareUrl = 'https://m.give-circle.com?annual_report=1'
} else {
this.shareUrl = 'https://m.qa.give543.com?annual_report=1'
}
},
computed: {
isNone () {
return this.commonwealDonateCount === 0 &&
this.getThanksCount === 0 &&
this.getFlowerCount === 0 &&
this.sendFlowerCount === 0 &&
this.momentCount === 0
},
hasShare () {
return this.shareNum > 0
},
shareNum () {
return this.giveQuantity + this.receiveQuantity
},
shareTitle () {
if (this.shareNum === 0) {
return ''
}
let titlesGender = titles[this.gender === 'UNKOWN' || this.gender === 'OTHER' || !this.gender ? 'FEMALE' : this.gender]
if (!titlesGender) {
titlesGender = titles['FEMALE']
}
for (let title of titlesGender) {
if (this.shareNum >= title.value) {
return title.title
}
}
}
},
watch: {
showValue (val) {
if (val) {
this.showAll = false
this.getUserReport()
if (this.step === 1) {
setTimeout(() => {
this.showAll = true
}, 900)
}
if (!this.timer) {
this.timer = setInterval(() => {
this.rabbitIndex = (++this.rabbitIndex) % 2
this.rabbitImg = this.rabbitIndex === 0 ? rabbit1 : rabbit2
}, 600)
}
} else {
if (this.timer) {
clearInterval(this.timer)
this.timer = null
}
}
}
},
methods: {
nextStep () {
if (!local.get(KEY_USER_TOKEN)) {
this.router.push('/login?annual_report=1')
this.showValue = false
} else {
this.step = 1
setTimeout(() => {
this.showAll = true
}, 900)
}

this.$ga.trackEvent('annual_report', 'open', 'annual_report_show')
},
getUserReport () {
if (!this.userId) {
return
}
this.loading = true
userApi.getUserAnnualReport(this.userId, this.year)
.then(data => {
this.giveQuantity = data.give_quantity
this.receiveQuantity = data.receive_quantity
this.sendFlowerCount = data.send_flower_count
this.getFlowerCount = data.get_flower_count
this.commonwealDonateCount = data.commonweal_donate_count
this.getThanksCount = data.get_thanks_count
this.momentCount = data.moment_count
this.firstSender = data.first_sender
this.firstThank = data.first_thank
this.gender = data.gender
this.loading = false
})
.catch(err => {
console.log(err)
})
},
async handleSave () {
this.showAll = true
const dom = document.querySelector('#annual-report')
const width = dom.clientWidth
const height = dom.clientHeight
const canvas = document.createElement('canvas')
const scale = this.DPR()
canvas.width = width * scale
canvas.height = height * scale

canvas.style.width = width * scale + 'px'
canvas.style.height = height * scale + 'px'


await html2canvas(dom, {
scale,
canvas,
useCORS: true
})
const dataImg = canvas.toDataURL()
const url = URL.createObjectURL(dataURLtoBlob(dataImg))

var a = document.createElement('a')
a.href = url
a.download = url.replace(/(.*\/)*([^.]+.*)/ig, '$2').split('?')[0]

const saveElement = document.createElement('a')
saveElement.download = 'image.png'
saveElement.href = url
const evt = document.createEvent('MouseEvents')
evt.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null)

saveElement.dispatchEvent(evt)
},
async handleShare () {
this.showAll = true
this.shareLoading = true
const dom = document.querySelector('#annual-report')
const width = dom.clientWidth
const height = dom.clientHeight
const canvas = document.createElement('canvas')
const scale = this.DPR()
canvas.width = width * scale
canvas.height = height * scale

canvas.style.width = width * scale + 'px'
canvas.style.height = height * scale + 'px'


await html2canvas(dom, {
scale,
canvas,
useCORS: true
})
const dataImg = canvas.toDataURL()
const blobArg = dataURLtoBlob(dataImg)
thingApi.uploadImgNew(blobArg, 'resource', true)
.then(data => {
this.shareLoading = false
this.shareImage = data.url.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
this.shareUrl = this.shareImage
this.showShareBar()
})
.catch(err => {
this.shareLoading = false
console.log(err)
this.showShareBar()
})
},
DPR () {
if (window.devicePixelRatio && window.devicePixelRatio > 1) {
return window.devicePixelRatio
}
return 1
},
close () {
this.showValue = false
},
showShareBar () {
this.isShowShareBar = true
},
hideShareBar () {
this.isShowShareBar = false
},
handleSponsor () {
this.router.push('/sponsorship')
this.close()
}
}
}
